import PDFIcon from "../../Images/pdfIcon.png";

const ShareholdingPattern = () => {
  const documents = [
    {
      label: "View Shareholding Pattern 2025",
      fileName: "Shareholding-Pattern-2025.pdf",
    },
    // Add future files here:
    // { label: "View Shareholding Pattern", fileName: "Shareholding-Pattern-2026.pdf" },
  ];

  return (
    <div className="py-80">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-4">
            <div className="site-heading">
              <span className="site-title-tagline">Investor Information</span>
                <h2 className="site-title">
                  Shareholding <span>Pattern 2025</span>
                </h2>
              <div className="heading-divider"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {documents.map((doc, id) => (
            <div className="col-md-6 col-lg-4" key={id}>
              <div className="team-item p-3">
                <img src={PDFIcon} alt="pdf icon" />
                <div className="team-content">
                  <div className="team-bio">
                    <h5>Shareholding Pattern 2025</h5>
                    <a
                      className="theme-btn mt-2"
                      href={`https://essexmpl.com/Pdf/${doc.fileName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {doc.label}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShareholdingPattern;
